<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v">For Rhett, the coolest little dude I’ve ever met</a></p><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4acd89f1